import React, { useState, useEffect } from "react";
import { map } from "lodash";
import { useDispatch, useSelector } from "react-redux";
import { performLogout } from "../../redux/AuthAction.js";
import { useHistory, useLocation } from "react-router-dom";
import {
    LanguageOption,
    ApiUrl,
    ApiKey,
    SessionKey,
    WebUrl,
} from "./../../util/Constant.js";
import {
    setBusy,
    setIdle,
    setIsShowCreateShareHolderPin,
    setIsShowVerifyShareHolderPin,
} from "../../redux/AppAction.js";
import { setDisplayLogin, setDisplayRegister } from "../../redux/AppAction";
import { useTranslation } from "react-i18next";
import { saveLanguageId } from "../../redux/LanguageAction.js";
import ApiEngine from "./../../util/ApiEngine.js";
import { createMultiPartFormBody, stringIsNullOrEmpty } from "./../../util/Util.js";
import ShareHolderAuth from "../auth/ShareHolderAuth.js";

const SideMenu = () => {
    const { t, i18n } = useTranslation();
    const location = useLocation();
    const search = window.location.search;
    const params = new URLSearchParams(search);
    var _dispatch = useDispatch();
    const _history = useHistory();
    const { isLoggedIn } = useSelector((state) => state.authState);
    var _userData = useSelector((state) => state.authState.userData);
    var totalDownlines = useSelector((state) => state.authState.totalDownlines);
    var dailyCheckinStatus = useSelector((state) => state.appState.dailyCheckinStatus);
    const [downloadURL, setDownloadURL] = useState("");
    const [isLogoutProcess, setIsLogoutProcess] = useState(false);
    const sideMenuData = [ //not logged in
        {
            image: "/img/version3/menu/home.svg",
            label: "HOME",
            link: WebUrl._URL_MAIN,
            isAuth: false,
            category: ""
        },
        {
            image: "/img/version3/menu/memberbenefit.svg",
            label: "MEMBER_BENEFIT",
            link: WebUrl._URL_MEMBER_BENEFIT,
            isAuth: false
        },
        {
            image: "/img/version3/menu/promotion.svg",
            label: "PROMOTION",
            link: WebUrl._URL_PROMOTION,
            isAuth: false
        },
        {
            image: "/img/version3/menu/bigwinning-icon.svg",
            label: "BIG_WINNING",
            link: WebUrl._URL_BIG_WINNING,
            isAuth: false,
            category: "big-winning"
        },
        {
            image: "/img/version3/menu/check-in.svg",
            label: "DAILY_CHECK_IN",
            link: WebUrl._URL_DAILY_CHECK_IN,
            isAuth: true,
            category: "daily-check-in"
        },
        {
            image: "/img/version3/menu/game-point.svg",
            label: "GAMEPOINT_REDEMPTION",
            link: WebUrl._URL_LOYALTY_REDEMPTION,
            isAuth: true,
            category: "loyalty"
        },
        {
            image: "/img/version3/menu/rewards.svg",
            label: "REWARDS",
            link: WebUrl._URL_REWARDS,
            isAuth: true,
            category: "rewards"
        },
        {
            image: "/img/version3/menu/kpi.svg",
            label: "KPI",
            link: WebUrl._URL_KPI,
            isAuth: true,
            category: "kpi"
        },
        {
            image: "/img/version3/menu/4d.svg",
            label: "4D_RESULT",
            link: WebUrl._URL_4D_RESULT,
            isAuth: false,
            category: "4d-result"
        },
        {
            image: "/img/version3/menu/referral.svg",
            label: "REFERRAL",
            link: WebUrl._URL_REFERRAL,
            isAuth: true,
            category: "referral"
        },
        {
            image: "/img/version3/menu/downline.svg",
            label: "DOWNLINES",
            link: WebUrl._URL_DOWNLINE,
            isAuth: true,
            category: "downline"
        },
        {
            image: "/img/version3/menu/vip.svg",
            label: "VIP_EVENT",
            link: WebUrl._URL_VIP +
                "?GAzobE73Vse4nr8WpufA=" +
                _userData.hideSummary,
            isAuth: true,
            category: "vip-event"
        },
        {
            image: "/img/version3/menu/reports.svg",
            label: "REPORTS",
            link: WebUrl._URL_REPORT,
            isAuth: true,
            category: "report"
        },
        {
            image: "/img/version3/menu/video-tutorial.svg",
            label: "VIDEO_TUTORIAL",
            link: WebUrl._URL_VIDEO_TUTORIAL,
            isAuth: false,
            category: "video-tutorial"
        },
        {
            image: "/img/version3/menu/live-chat.svg",
            label: "LIVE_CHAT",
            link: WebUrl._URL_CONTACT_US,
            isAuth: false,
            category: "contact-us"
        },
        {
            image: "/img/version3/menu/setting.svg",
            label: "SETTINGS",
            link: WebUrl._URL_SETTINGS,
            isAuth: false,
            category: "settings"
        },
    ];

    const sideMenuData2 = [ //not logged in
        {
            image: "/img/version3/menu/home.svg",
            label: "HOME",
            link: WebUrl._URL_MAIN,
            isAuth: false
        },
        //{
        //    image: "/img/version3/menu/memberbenefit.svg",
        //    label: "MEMBER_BENEFIT",
        //    link: WebUrl._URL_MEMBER_BENEFIT,
        //    isAuth: false
        //},
        {
            image: "/img/version3/menu/promotion.svg",
            label: "PROMOTION",
            link: WebUrl._URL_PROMOTION,
            isAuth: false
        },
        {
            image: "/img/version3/menu/bigwinning-icon.svg",
            label: "BIG_WINNING",
            link: WebUrl._URL_BIG_WINNING,
            isAuth: false,
            category: "big-winning"
        },
        {
            image: "/img/version3/menu/check-in.svg",
            label: "DAILY_CHECK_IN",
            link: WebUrl._URL_DAILY_CHECK_IN,
            isAuth: true,
            category: "daily-check-in"
        },
        {
            image: "/img/version3/menu/rewards.svg",
            label: "REWARDS",
            link: WebUrl._URL_REWARDS,
            isAuth: false,
            category: "rewards"
        },
        {
            image: "/img/version3/menu/game-point.svg",
            label: "GAMEPOINT_REDEMPTION",
            link: WebUrl._URL_LOYALTY_REDEMPTION,
            isAuth: false,
            category: "loyalty"
        },
        {
            image: "/img/version3/menu/4d.svg",
            label: "RESULT",
            link: WebUrl._URL_4D_RESULT,
            isAuth: false,
            category: "4d-result"
        },
        {
            image: "/img/version3/menu/about.svg",
            label: "ABOUT_US",
            link: WebUrl._URL_ABOUT.replace(":category", "about-us"),
            isAuth: false
        },
        {
            image: "/img/version3/menu/help-centre.svg",
            label: "HELP_CENTRE",
            link: WebUrl._URL_HELP_CENTRE,
            isAuth: false
        },
        {
            image: "/img/version3/menu/afffilate.svg",
            label: "AFFILIATE_PARTNER_PROGRAM",
            link: WebUrl._URL_ABOUT.replace(":category", "affiliate-partner-program"),
            isAuth: false
        },
        {
            image: "/img/version3/menu/privacy.svg",
            label: "PRIVACY_POLICY",
            link: WebUrl._URL_ABOUT.replace(":category", "privacy-policy"),
            isAuth: false
        },

        {
            image: "/img/version3/menu/tnc.svg",
            label: "TERMS_AND_CONDITIONS",
            link: WebUrl._URL_ABOUT.replace(":category", "terms-and-conditions"),
            isAuth: false
        },
        {
            image: "/img/version3/menu/responsible-gambling.svg",
            label: "RESPONSIBLE_GAMBLING",
            link: WebUrl._URL_ABOUT.replace(":category", "responsible-gambling"),
            isAuth: false
        },

    ];

    const sideMenuData3 = [
        {
            image: "/img/version3/menu/download-app.svg",
            label: "DOWNLOAD_APP",
            link: downloadURL,
            isAuth: false
        },
    ];

    useEffect(() => {
        // const value = LanguageOption.find((item) => localStorage.getItem(SessionKey._LANGUAGE) === item.code );
        if (params.get("languageCode") != null) {
            onChangeLanguage(params.get("languageCode"));
            localStorage.setItem(SessionKey._LANGUAGE, params.get("languageCode"));
        }
        else if (localStorage.getItem(SessionKey._LANGUAGE) && localStorage.getItem(SessionKey._LANGUAGE) != 'undefined') {
            if (LanguageOption.find(
                (x) => x.code === localStorage.getItem(SessionKey._LANGUAGE)) != undefined) {

                let downloadURL = (window.location.href.includes("staging") || window.location.href.includes("localhost")) ?
                    "http://download.i8global.com/?lang = " + localStorage.getItem(SessionKey._LANGUAGE) + " & country=my"
                    :
                    "http://download.i8dua.com/?lang=" + localStorage.getItem(SessionKey._LANGUAGE) + "&country=my"
                    ;

                setDownloadURL(downloadURL);
                i18n.changeLanguage(localStorage.getItem(SessionKey._LANGUAGE));
            }
            else {
                i18n.changeLanguage("en");
                let downloadURL = (window.location.href.includes("staging") || window.location.href.includes("localhost")) ?
                    "http://download.i8dua.com/?lang=" + localStorage.getItem(SessionKey._LANGUAGE) + "&country=my"
                    :
                    "http://download.i8dua.com/?lang=" + localStorage.getItem(SessionKey._LANGUAGE) + "&country=my"
                    ;

                setDownloadURL(downloadURL);
                localStorage.setItem(SessionKey._LANGUAGE, "en");
            }
        } else {
            i18n.changeLanguage("en");
            let downloadURL = (window.location.href.includes("staging") || window.location.href.includes("localhost")) ?
                "http://download.i8dua.com/?lang=" + localStorage.getItem(SessionKey._LANGUAGE) + "&country=en"
                :
                "http://download.i8dua.com/?lang=" + localStorage.getItem(SessionKey._LANGUAGE) + "&country=en"
                ;

            setDownloadURL(downloadURL);
            localStorage.setItem(SessionKey._LANGUAGE, "en");
        }
    }, [(localStorage.getItem(SessionKey._LANGUAGE) && localStorage.getItem(SessionKey._LANGUAGE) != 'undefined' ?
        localStorage.getItem(SessionKey._LANGUAGE) : 'en')]);

    const onChangeLanguage = async (selectedLanguage) => {
        _dispatch(setBusy());
        i18n.changeLanguage(selectedLanguage);
        if (!isLoggedIn) {
            _dispatch(saveLanguageId(selectedLanguage, true));
        } else {
            _dispatch(saveLanguageId(selectedLanguage));
            let data = {};
            // data["id"] = _userData.userId;
            // data["selectedTheme"] = _userData.selectedTheme;
            data["languageSetting"] = selectedLanguage;
            // data["isMemberOperate"] = true;

            // Silently update user's language settings
            await ApiEngine.post(
                // ApiUrl._API_CREATE_OR_UPDATE_MEMBER,
                ApiUrl._API_UPDATE_MEMBER_LANGUAGE,
                createMultiPartFormBody(data)
            );

            if (window.ReactNativeWebView) {
                window.ReactNativeWebView.postMessage(
                    JSON.stringify({
                        action: "language",
                        language: selectedLanguage,
                    })
                );
            }

        }
        _dispatch(setIdle());
    };

    const onClickSideMenu = async (item) => {
        if (item.label === "VIP_EVENT") {
            if (location.pathname !== WebUrl._URL_VIP && isLoggedIn) {
                if (!stringIsNullOrEmpty(localStorage.getItem("6FAZhVi1QvBGsKaUl7WPhVTwRPf1HUhF")) && localStorage.getItem("6FAZhVi1QvBGsKaUl7WPhVTwRPf1HUhF") === "wdAvBAPKCPB1TvXPsfPSda8PUUdEGaHg=") {
                    _history.push(item.link);
                } else {
                    if (_userData.isCreateShareHolderPin) {
                        _dispatch(setIsShowCreateShareHolderPin(true));
                        _dispatch(setIsShowVerifyShareHolderPin(false));
                    } else {
                        _dispatch(setIsShowCreateShareHolderPin(false));
                        _dispatch(setIsShowVerifyShareHolderPin(true));
                    }
                }
            }
        } else {
            _history.push(item.link)
        }
    }

    return (
        <>
            <div id="side-menu">
                {!isLoggedIn ?
                    <>
                        <div className="side-menu-top">
                            <div className="title">
                                {t("WELCOME_TO_I8LIVE")}
                            </div>
                            <div className="wave-icon">
                                <img src="/img/version3/menu/wave.png" alt="wave-icon" />
                            </div>
                        </div>
                    </>
                    :
                    <>
                        {/* ///show when login// */}
                        <div className="side-menu-top login">
                            <div>
                                <img src="/img/version3/menu/user.png" alt="user-icon" />
                            </div>
                            <div>
                                <div className="title">{_userData["username"]}</div>
                                <div className="details">{totalDownlines} {t("DOWNLINE")}</div>
                            </div>
                            {/* ///end show when login// */}
                        </div>
                        <hr className="hr-normal mt-3 mb-3" />
                    </>
                }
                <div className="side-menu-list">
                    {isLoggedIn &&
                        sideMenuData &&
                        sideMenuData.length &&
                        sideMenuData
                            .filter((x) => (!isLoggedIn ? !x.isAuth : !_userData.isShareHolder ? x.label !== "VIP_EVENT" : x))
                            .filter((x) => (!dailyCheckinStatus ? x.label !== "DAILY_CHECK_IN" : x))
                            .map((item, index) => {
                                return (
                                    <div key={"side-menu-items" + item.label} style={{ cursor: "pointer" }}
                                        onClick={() => { onClickSideMenu(item); }}>
                                        <div
                                            key={item.link}
                                            className={"side-menu-item " +
                                                (item.label === "BIG_WINNING" ? "big-winning-side-bar-second-div" : "") +
                                                " " +
                                                ((location.pathname.includes(item.category) && item.link !== '/') ? "active" : (location.pathname.substring(location.pathname.indexOf('/') + 1) === "" && item.link === '/') ? "active" : "") 
                                             
                                            }
                                        >
                                            <div className={"side-menu-icon " + (item.label === "MEMBER_BENEFIT" ? "member-benefit-side-bar-remove-filter" : "")} >
                                                <img
                                                    src={item.image}
                                                    alt={item.label}
                                                />
                                            </div>
                                            <div>{t(item.label)}</div>
                                        </div>
                                    </div>
                                );
                            })}
                </div>
                <hr className="hr-normal mt-3 mb-3" />
                <div className="side-menu-list">
                    {sideMenuData2 &&
                        sideMenuData2.length &&
                        sideMenuData2
                            .filter((x) => (isLoggedIn ? x.label !== "HOME" : x))
                            .filter((x) => (isLoggedIn ? x.label !== "MEMBER BENEFIT" : x))
                            .filter((x) => (isLoggedIn ? x.label !== "PROMOTION" : x))
                            .filter((x) => (isLoggedIn ? x.label !== "BIG_WINNING" : x))
                            .filter((x) => (isLoggedIn ? x.label !== "DAILY_CHECK_IN" : x))
                            .filter((x) => (isLoggedIn ? x.label !== "REWARDS" : x))
                            .filter((x) => (isLoggedIn ? x.label !== "GAMEPOINT_REDEMPTION" : x))
                            .filter((x) => (isLoggedIn ? x.label !== "RESULT" : x))
                            .map((item, index) => {
                                return (
                                    <div key={"side-menu-2-items" + item.label} onClick={() => { _history.push(item.link); }} style={{ cursor: "pointer" }}>
                                        <div className={"side-menu-item " + (item.label === "BIG_WINNING" ? "big-winning-side-bar-second-div" : "") + " " + (item.link === location.pathname ? "active" : "")}>
                                            <div className={"side-menu-icon " + (item.label === "MEMBER_BENEFIT" ? "member-benefit-side-bar-remove-filter" : "")} >
                                                <img
                                                    src={item.image}
                                                    alt={item.label}
                                                />
                                            </div>
                                            <div>{t(item.label)}</div>
                                        </div>
                                    </div>
                                );
                            })}
                </div>
                <hr className="hr-normal mt-3 mb-3" />
                <div className="side-menu-list">
                    {sideMenuData3 &&
                        sideMenuData3.length &&
                        map(sideMenuData3, (item, index) => {
                            return (
                                <a key={"side-menu-3-items" + item.label} href={item.link}>
                                    <div className={"side-menu-item " + (item.link === location.pathname ? "active" : "")}>
                                        <div className={"side-menu-icon " + (item.label === "MEMBER_BENEFIT" ? "member-benefit-side-bar-remove-filter" : "")} >
                                            <img
                                                src={item.image}
                                                alt={item.label}
                                            />

                                        </div>
                                        <div>{t(item.label)}</div>
                                    </div>
                                </a>
                            );
                        })}
                </div>
                {isLoggedIn ? (
                    <div className="logout-button mt-5">
                        <div className="first">
                            <img src="/img/version3/menu/logout.svg" alt="logout" />
                        </div>
                        <div onClick={() => {
                            setIsLogoutProcess(true);
                            _dispatch(performLogout());
                            _history.replace(WebUrl._URL_MAIN);
                            localStorage.removeItem('isReadAllNotification');
                            localStorage.removeItem('unreadNotificationCount');
                        }}>
                            {isLogoutProcess && isLoggedIn ? t("LOGGING_OUT") + "..." : t("LOGOUT")}</div>
                    </div>
                ) : (
                    <div className="mt-5 side-menu-login-register">
                        <div className="side-menu-login"><div onClick={() => _dispatch(setDisplayLogin(true))}>{t("LOGIN")}</div></div>
                        <div>|</div>
                        <div className="side-menu-register"><div onClick={() => _dispatch(setDisplayRegister(true))}>{t("REGISTER")}</div></div>
                    </div>
                )}
            </div>
            <ShareHolderAuth />
        </>
    );
};

export default SideMenu;
